import {Component} from "@angular/core";
import {FUIButtonComponent} from "../button.component";

@Component({
    selector: "fui-choice-button",
    styleUrls: ["./choice-button.component.scss"],
    templateUrl: "./choice-button.component.html"
})
export class FUIChoiceButtonComponent extends FUIButtonComponent {

}
